var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0zM2.77 12a9.23 9.23 0 1 1 18.46 0 9.23 9.23 0 0 1-18.46 0zm6.122-3.27a2.023 2.023 0 0 1 1.904-1.345h2.102a2.275 2.275 0 0 1 1.132 4.25l-1.165.668a.867.867 0 0 1-.865.85.863.863 0 0 1-.865-.865v-.486c0-.31.165-.595.436-.75l1.597-.916a.545.545 0 0 0-.27-1.017h-2.102a.284.284 0 0 0-.27.191l-.015.043a.865.865 0 0 1-1.63-.577l.014-.043-.003-.003zm1.954 6.732a1.154 1.154 0 1 1 2.308 0 1.154 1.154 0 0 1-2.308 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.05ae1d7e.svg";
export { ForwardRef as ReactComponent };